import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $inputs } = this;

  return (view = ViewFactory({
    NAME: 'FAWRYPAY_CONFIRM_VIEW',
    constants: {
      hasBackAction: false,
      get phone() { return getValueAtPath($inputs, '[phone].value') },
      get reference() { return $this.FAWRY_REFERENCE }
    },
    next() {
      // Once user has saved/copied the reference,
      // close/terminate the Checkout session.
    }
  }).call(this));
}
